import { render } from "./DiscountSetup.vue?vue&type=template&id=52f20cab&scoped=true"
import script from "./DiscountSetup.vue?vue&type=script&lang=js"
export * from "./DiscountSetup.vue?vue&type=script&lang=js"

import "./DiscountSetup.vue?vue&type=style&index=0&id=52f20cab&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f20cab"]])

export default __exports__